import React from "react";
import SelectDropdown from "./shared/SelectDropdown";

const DATA_FORMAT_OPTIONS = Object.freeze({
  processed: {
    label: "De-identified Data",
  },
  raw: {
    label: "Raw Data",
  },
});

const SubmissionDataFormatSelector = ({ showRaw, setShowRaw }) => {
  const value = showRaw ? "raw" : "processed";
  const options = Object.entries(DATA_FORMAT_OPTIONS).map(([key, option]) => ({
    value: key,
    ...option,
  }));

  return (
    <SelectDropdown
      options={options}
      value={value}
      onChange={(selected) => setShowRaw(selected === "raw")}
    />
  );
};

export default SubmissionDataFormatSelector;
